<!-- 
A skinny progress indicator.

Use the "show" prop to display. (We use this approach instead of just putting a "v-if" condition on the
component so that it takes up the same space regardless of whether it is visible.)

These are normally used at the top of dialog boxes while data is being loaded or saved.
We also have a "OurLoadingIndicator" component, which is a bigger, more intrusive twirly indicator,
useful for situations when you don't know what the layout will be until after your data has loaded.
-->
<template>
  <div style="height: 5px">
    <v-progress-linear v-if="show" indeterminate />
  </div>
</template>

<script>
export default {
  props: {
    show: {
      default: false,
      type: Boolean
    }
  }
};
</script>
